import { get } from "../../utils/axios-config";
import { CLAIMS } from "../../utils/constants";

export const getClaims = async () => await get<string[]>(CLAIMS);